module.exports = __webpack_public_path__ + "img/logo_frax.f69c9956.png";